export interface FilterableItem {
    name: string;
    description: string;
    businessAreaId: string;
    courseDate?: string;
    statuscode?: number;
    reportedby?: string;
}

export enum FilterType {
    Course = "Course",
    Knowledge = "Knowledge",
    Message = "Message",
    Case = "Case",
    Default = "Default"
}
